import { render, staticRenderFns } from "./ActivitiesProjectTable.vue?vue&type=template&id=b945b2d2&"
import script from "./ActivitiesProjectTable.vue?vue&type=script&lang=js&"
export * from "./ActivitiesProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports